
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gp/mimovistar",
      function () {
        return require("private-next-pages/gp/mimovistar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gp/mimovistar"])
      });
    }
  